import { useState, useEffect } from 'react';
import { tasksAPI, journalAPI } from '../services/api';

/**
 * Manages global search across all tasks and journal entries.
 */
export function useTaskSearch() {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState({ tasks: [], journals: [] });
  const [isSearching, setIsSearching] = useState(false);
  const [allTasks, setAllTasks] = useState([]);

  useEffect(() => {
    const performSearch = async () => {
      if (!searchQuery.trim()) {
        setSearchResults({ tasks: [], journals: [] });
        setIsSearching(false);
        return;
      }

      setIsSearching(true);
      const query = searchQuery.toLowerCase();

      try {
        let tasksToSearch = allTasks;
        if (allTasks.length === 0) {
          const fetchedTasks = await tasksAPI.getTasks();
          setAllTasks(fetchedTasks);
          tasksToSearch = fetchedTasks;
        }

        const matchingTasks = tasksToSearch.filter(task =>
          task.title.toLowerCase().includes(query) ||
          (task.description && task.description.toLowerCase().includes(query))
        );

        // Search journals from server
        const matchingJournals = await journalAPI.search(searchQuery);

        setSearchResults({ tasks: matchingTasks, journals: matchingJournals });
      } catch (error) {
        console.error('Search failed:', error);
      }
    };

    const debounceTimer = setTimeout(performSearch, 300);
    return () => clearTimeout(debounceTimer);
  }, [searchQuery, allTasks]);

  const clearSearch = () => {
    setSearchQuery('');
    setSearchResults({ tasks: [], journals: [] });
    setIsSearching(false);
  };

  return {
    searchQuery,
    setSearchQuery,
    searchResults,
    isSearching,
    clearSearch,
  };
}
